import React, { ReactNode, useContext, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import {
	StorageMenu,
	componentPagesMenu,
	dashboardPagesMenu,
	demoPagesMenu,
	gettingStartedPagesMenu,
	pageLayoutTypesPagesMenu,
} from '../../../menu';
import ThemeContext from '../../../contexts/themeContext';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import Hand from '../../../assets/img/hand.png';
import HandWebp from '../../../assets/img/hand.webp';
import Icon from '../../../components/icon/Icon';
import Button from '../../../components/bootstrap/Button';
import useDarkMode from '../../../hooks/useDarkMode';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import { AddOption } from '../../Filez/helper';
import Progress from '../../../components/bootstrap/Progress';
// import AddFolder from '../../../components/FilezComponents/FolderManagement/AddFolder';
import CreateFolderModal from '../../Filez/FolderManagement/components/CreateFolderModal';
import { useSelector, useDispatch } from 'react-redux'
import { createFile, uploadDocument, fetchFilesByMode } from '../../../redux/Slice/FlieSlice';
import { ModeId } from '../../../utils';

const DefaultAside = () => {
	const dispatch = useDispatch()
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	const [doc, setDoc] = useState(
		localStorage.getItem('Filez_asideDocStatus') === 'true' || false,
	);

	const { t } = useTranslation(['translation', 'menu']);

	const { darkModeStatus } = useDarkMode();
	const handleFileChange = async (event: any) => {
		if (event.target.files && event.target.files[0]) {
			const fileName: string = event.target.files[0].name;



			const res = await dispatch(createFile({
				file_name: fileName,
				mode: ModeId,
				is_video: false,
				is_image: false,
				is_doc: false,
				is_deleted: false,
				is_starred: false
			}) as any);
			console.log(res, "rea")
			await dispatch(uploadDocument({
				id: res?.payload?.data?._id,
				file: event.target.files[0]
			}) as any)
		} else {
			console.error("No file selected or invalid file object.");
		}

	};

	const [Modal, setModal] = useState(false)
	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>

			<AsideBody>
				<div className='row justify-content-center border border-light'>
					<div className=' text-center w-100 '>
						<div
							style={{
								position: 'relative',
								border: '2px rgb(35 35 44) solid',

							}}
							className='AddMenu '>
							<Button className='text-light' onClick={() => setModal(!Modal)} isLight>
								+ ADD FOLDER
							</Button>

						</div>
					</div>
				</div>
				{!doc && (
					<>
						<Navigation menu={dashboardPagesMenu} id='aside-dashboard' />
						<NavigationLine />
						{/* <Navigation menu={demoPagesMenu} id='aside-demo-pages' />
						<NavigationLine />
						<Navigation menu={pageLayoutTypesPagesMenu} id='aside-menu' /> */}
					</>
				)}

				{!doc && (
					<>
						<Navigation menu={StorageMenu} id='aside-docMenu' />
					</>
				)}

				<div className='px-3'>
					<Progress value={35} />
					<div className='text-center'>
						<p>6.65 GB of 15 GB used</p>
					</div>
					<div className='text-center'>
						<Button className='text-light AddMenu border border-light' isLight>
							Get more storage
						</Button>
					</div>
				</div>

				{/* {asideStatus && doc && (
					<Card className='m-3 '>
						<CardBody className='pt-0'>
							<img srcSet={HandWebp} src={Hand} alt='Hand' width={130} height={130} />
							<p
								className={classNames('h4', {
									'text-dark': !darkModeStatus,
									'text-light': darkModeStatus,
								})}>
								{t('Everything is ready!') as ReactNode}
							</p>
							<Button
								color='info'
								isLight
								className='w-100'
								onClick={() => {
									localStorage.setItem('Filez_asideDocStatus', 'false');
									setDoc(false);
								}}>
								{t('Demo Pages') as ReactNode}
							</Button>
						</CardBody>
					</Card>
				)} */}
			</AsideBody>
			<AsideFoot>
				<></>
				{/* <nav aria-label='aside-bottom-menu'>
					<div className='navigation'>
						<div
							role='presentation'
							className='navigation-item cursor-pointer'
							onClick={() => {
								localStorage.setItem('Filez_asideDocStatus', String(!doc));
								setDoc(!doc);
							}}
							data-tour='documentation'>
							<span className='navigation-link navigation-link-pill'>
								<span className='navigation-link-info'>
									<Icon
										icon={doc ? 'ToggleOn' : 'ToggleOff'}
										color={doc ? 'success' : undefined}
										className='navigation-icon'
									/>
									<span className='navigation-text'>
										{t('menu:Documentation') as ReactNode}
									</span>
								</span>
								<span className='navigation-link-extra'>
									<Icon
										icon='Circle'
										className={classNames(
											'navigation-notification',
											'text-success',
											'animate__animated animate__heartBeat animate__infinite animate__slower',
										)}
									/>
								</span>
							</span>
						</div>
					</div>
				</nav> */}
				{/* <User /> */}
			</AsideFoot>
			<CreateFolderModal setIsOpen={setModal} isOpen={Modal} />
		</Aside>
	);
};

export default DefaultAside;
